import { EmfWidgetDbModel } from "./components/widget/widget.models";

export class WidgetDbDemoModel extends EmfWidgetDbModel {

  constructor(dbItem: EmfWidgetDbModel) {
    super()
    this.active = dbItem.active
    this.category = dbItem.category
    this.description = dbItem.description
    this.height = dbItem.height
    this.icon = dbItem.icon
    this.id = dbItem.id
    this.name = dbItem.name
    this.order = dbItem.order
    this.params = dbItem.params
    this.settings = dbItem.settings
    this.type = dbItem.type
    this.version = dbItem.version
    this.width = dbItem.width
    this.title = dbItem.title
    this.subTitle = dbItem.subTitle
    this.config = dbItem.config
  }


  private prepareAttrAsQueryString(): string {
    var str = [];
    this.params.forEach(p => {
      str.push(p.name + "=" + encodeURIComponent(p.value));
    })
    return str.join("&");
  }

  private prepareAttrAsJsonString(): string {
    var obj = {};
    this.params.forEach(p => {
      obj[p.name] = p.value;
    });
    let jsonStr = JSON.stringify(obj, null, "\t");
    const unquoted = jsonStr.replace(/"([^"]+)":/g, '$1:');
    var result = unquoted.replaceAll("\"", "'");
    return result;
  }

  getAttr() {
    //let attr = WidgetService.useJsonAttr ? this.prepareAttrAsJsonString() : this.prepareAttrAsQueryString();
    let attr = this.prepareAttrAsQueryString()
    return attr;
  }

  getHtml(): string {
    let attrString = this.getAttr();
    let html = `<div data-widget="emf" data-type="${this.type}" data-attr="${attrString}"></div>`
    return html;
  }
}

export class WidgetConfigurationPanelDataModel {
  currentWidget: WidgetDbDemoModel;
  onApplyClick?: (data: WidgetDbDemoModel) => void;
}